import React, { useState } from 'react';
import { ShieldCheckIcon, ArrowRightIcon, ArrowLeftIcon, SmartphoneIcon, CreditCardIcon } from 'lucide-react';
interface LoginPageProps {
  onLoginSuccess: () => void;
  navigate: (page: string) => void;
  t: (key: string) => string;
}
export function LoginPage({
  onLoginSuccess,
  navigate,
  t
}: LoginPageProps) {
  const [step, setStep] = useState<1 | 2>(1);
  const [loginType, setLoginType] = useState<'mobile' | 'nid'>('mobile');
  const [inputValue, setInputValue] = useState('');
  const [otp, setOtp] = useState('');
  const handleStep1Submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (inputValue.trim()) {
      setStep(2);
    }
  };
  const handleStep2Submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (otp === '123456') {
      onLoginSuccess();
    } else {
      alert('Invalid OTP. Use 123456 for prototype.');
    }
  };
  return <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-4" data-id="element-491">
      <div className="w-full max-w-md" data-id="element-492">
        <div className="text-center mb-8" data-id="element-493">
          <div className="w-16 h-16 bg-[#006A4E] rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg" data-id="element-494">
            <ShieldCheckIcon className="w-8 h-8 text-white" data-id="element-495" />
          </div>
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-496">
            {t('login.title')}
          </h1>
          <p className="text-slate-500 mt-2" data-id="element-497">{t('login.subtitle')}</p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl border border-slate-100 overflow-hidden" data-id="element-498">
          <div className="h-2 bg-gradient-to-r from-[#006A4E] via-[#00875A] to-[#D4A843]" data-id="element-499"></div>

          <div className="p-6 md:p-8" data-id="element-500">
            {step === 1 ? <form onSubmit={handleStep1Submit} className="space-y-6" data-id="element-501">
                <div className="flex p-1 bg-slate-100 rounded-lg" data-id="element-502">
                  <button type="button" onClick={() => setLoginType('mobile')} className={`flex-1 py-2 text-sm font-medium rounded-md flex items-center justify-center gap-2 transition-colors ${loginType === 'mobile' ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-503">
                    <SmartphoneIcon className="w-4 h-4" data-id="element-504" /> {t('login.mobile')}
                  </button>
                  <button type="button" onClick={() => setLoginType('nid')} className={`flex-1 py-2 text-sm font-medium rounded-md flex items-center justify-center gap-2 transition-colors ${loginType === 'nid' ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-505">
                    <CreditCardIcon className="w-4 h-4" data-id="element-506" /> {t('login.nid')}
                  </button>
                </div>

                <div data-id="element-507">
                  <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-508">
                    {loginType === 'mobile' ? 'Mobile Number' : 'National ID Number'}
                  </label>
                  <input type="text" value={inputValue} onChange={e => setInputValue(e.target.value)} placeholder={loginType === 'mobile' ? 'e.g. 01712345678' : 'e.g. 1987654321098'} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#006A4E] focus:border-[#006A4E] outline-none transition-all" required data-id="element-509" />
                </div>

                <button type="submit" className="w-full bg-[#006A4E] hover:bg-[#00523c] text-white py-3 rounded-lg font-medium transition-colors flex items-center justify-center gap-2" data-id="element-510">
                  {t('login.continue')} <ArrowRightIcon className="w-4 h-4" data-id="element-511" />
                </button>
              </form> : <form onSubmit={handleStep2Submit} className="space-y-6" data-id="element-512">
                <button type="button" onClick={() => setStep(1)} className="text-sm text-slate-500 hover:text-slate-800 flex items-center gap-1 mb-4" data-id="element-513">
                  <ArrowLeftIcon className="w-4 h-4" data-id="element-514" /> {t('common.back')}
                </button>

                <div data-id="element-515">
                  <h3 className="text-lg font-bold text-slate-900 mb-1" data-id="element-516">
                    {t('login.verify')}
                  </h3>
                  <p className="text-sm text-slate-500 mb-6" data-id="element-517">
                    We've sent a 6-digit code to {inputValue}
                  </p>

                  <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-518">
                    Enter OTP Code
                  </label>
                  <input type="text" value={otp} onChange={e => setOtp(e.target.value)} placeholder="123456" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#006A4E] focus:border-[#006A4E] outline-none transition-all text-center tracking-[0.5em] font-mono text-lg" maxLength={6} required data-id="element-519" />
                  <p className="text-xs text-slate-400 mt-2 text-center" data-id="element-520">
                    Hint: Use 123456 for prototype
                  </p>
                </div>

                <button type="submit" className="w-full bg-[#006A4E] hover:bg-[#00523c] text-white py-3 rounded-lg font-medium transition-colors" data-id="element-521">
                  Verify & Login
                </button>
              </form>}
          </div>
        </div>
      </div>
    </div>;
}